import { Button, Modal, notification } from 'antd'
import { useState } from 'react'
import { NOTIFICATION_DURATION } from '~/common/constants'
import { useNotifications } from '~/views/app/redux/hooks/useNotification'
export default function DeleteNotification(props) {
  const { t = {}, title = null, action = {}, dataGuild, refreshData } = props
  const [isLoadingDelete, setIsloadingDelete] = useState(false)

  const okButtonStyle = {
    fontWeight: 'bold',
    padding: '10px',
    color: '#fff',
    backgroundColor: '#FAA52C',
    width: '50%',
    height: '48px',
    borderRadius: '4px',
  }
  const cancelButtonStyle = {
    fontWeight: 'bold',
    padding: '10px',
    color: '#fff',
    width: '50%',
    height: '48px',
    backgroundColor: 'transparent',
    border: 'none',
  }

  const { actions } = useNotifications()

  const handleSubmit = () => {
    const params = {
      id: dataGuild?._id,
    }
    try {
      setIsloadingDelete(true)
      actions?.deleteNotification(params, (res) => {
        if (res?.data === true) {
          onSuccess()
          setIsloadingDelete(false)
        } else {
          onError()
          setIsloadingDelete(false)
        }
      })
    } catch (error) {
      setIsloadingDelete(false)
    }
  }

  const onSuccess = () => {
    notification.success({
      message: t('common.message.deletenotificationSuccessfully'),
      placement: 'topRight',
      duration: NOTIFICATION_DURATION,
    })
    action?.handleCancel()
    refreshData()
  }
  const onError = () => {
    action?.handleCancel()
    refreshData()
  }

  return (
    <>
      <Modal
        centered
        getContainer={false}
        title={
          <h3 className="flex justify-center text-xl font-normal text-[#fff]">
            {title ?? t('common.titleConfirmDeleteModal')}
          </h3>
        }
        open={action?.isModalOpen}
        onCancel={action?.handleCancel}
        footer={[
          <div key="buttons" className="flex justify-center">
            <Button
              key="cancel"
              onClick={action?.handleCancel}
              style={cancelButtonStyle}
            >
              {t('cancel_sell.cancel')}
            </Button>
            <Button
              key="ok"
              type="primary"
              onClick={() => handleSubmit()}
              style={okButtonStyle}
              loading={isLoadingDelete}
            >
              {t('cancel_sell.ok')}
            </Button>
          </div>,
        ]}
      >
        <div className="text-center text-[16px]">
          {t('common.messConfirmDeleteModal')}
        </div>
      </Modal>
    </>
  )
}
